export const DESKTOP_TARGET = 'desktop'
export const MOBILE_TARGET = 'mobile'
export type TargetType = typeof DESKTOP_TARGET | typeof MOBILE_TARGET
